import React, { useState } from "react";
import Text from "./Text";

const CustomCheckbox = ({ label, onChange, ischecked }) => {
  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = () => {
    const newChecked = !ischecked;

    if (onChange) onChange(newChecked);
  };

  return (
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        checked={ischecked}
        onChange={handleCheckboxChange}
        id="checkbox"
        className="w-5 h-5 border-2 border-gray-300 rounded-sm focus:ring-2 focus:ring-blue-500 checked:bg-blue-500"
      />
      <label htmlFor="checkbox" className="inline text-center ">
        {label}
      </label>
    </div>
  );
};

export default CustomCheckbox;
